export const AGRINOUS = "AgriNous";
